import {
  Add,
  AppsOutlined,
  Assignment,
  AssignmentLateOutlined,
  AssignmentReturnedOutlined,
  AssignmentTurnedInOutlined,
  Attachment,
  BarChart,
  Code,
  Email,
  ErrorOutlineRounded,
  Event,
  ExpandLess,
  ExpandMore,
  FactCheck,
  FileCopy,
  Home,
  LocalHospital,
  LocalHospitalOutlined,
  LockClockOutlined,
  PeopleOutline,
  Person,
  QrCode2,
  QueryBuilder,
  Search,
  Send,
  SettingsOutlined,
  DirectionsCar,
} from "@mui/icons-material";
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import DescriptionIcon from "@mui/icons-material/Description";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import PersonIcon from '@mui/icons-material/Person';
import { Collapse, ListItemIcon } from "@mui/material";
import Badge from "@mui/material/Badge";
import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { StyledDrawer } from "../../styled/layout";
import DrawerItemTooltip from "./drawerItemTooltip";
import ListItemComponent from "./listItem";
import ListSubItemComponent from "./listSubItem";

const NestedList = () => {
  const [open, setOpen] = React.useState(true);

  const location = useLocation();

  const roles = useSelector((state) => state.auth.roles);
  const drawerOpen = useSelector((state) => state.userPreferences.drawer);
  const answeredAuthorizationsCount = useSelector(
    (state) => state.answeredAuthorizations.notification,
  );
  const erroresConectividadNoProcesados = useSelector(
    (state) => state.connectivityResponse.allConnectivityErrorsNotProcessed,
  );
  const messagingPendingCount = useSelector(
    (state) => state.messaging.pendingCount,
  );
  const [openUsuarios, setOpenUsuarios] = React.useState(true);
  const [openAccidents, setOpenAccidents] = React.useState(true);
  const [openMenu, setOpenMenu] = React.useState(true);
  const [openXml, setOpenXml] = React.useState(true);
  const [openNovedades, setOpenNovedades] = React.useState(false);
  const [openAppointment, setOpenAppointment] = React.useState(true);
  const [openMensajeria, setOpenMensajeria] = React.useState(true);
  const [openErroresConectividad, setOpenErroresConectividad] =
    React.useState(true);
  const [openTurnos, setOpenTurnos] = React.useState(false);
  const [openPrestadores, setOpenPrestadores] = React.useState(true);
  const [openValidarXML, setOpenValidarXML] = React.useState(false);
  const [openArt, setOpenArt] = React.useState(true);
  const [openNotificaciones, setOpenNotificaciones] = React.useState(true);
  const [openArtConfiguration, setOpenArtConfiguration] = React.useState(true);
  const [openTraslados, setOpenTraslados] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleClickNovedades = () => {
    setOpenNovedades(!openNovedades);
  };

  const handleClickTurnos = () => {
    setOpenTurnos(!openTurnos);
  };

  const handleClickAccidents = () => {
    setOpenAccidents(!openAccidents);
  };

  const handleClickMenu = () => {
    setOpenMenu(!openMenu);
  };

  const handleClickAppointment = () => {
    setOpenAppointment(!openAppointment);
  };
  const handleClickErroresConectividad = () => {
    setOpenErroresConectividad(!openErroresConectividad);
  };

  const handleClickMensajeria = () => {
    setOpenMensajeria(!openMensajeria);
  };

  const handleClickPrestadores = () => {
    setOpenPrestadores(!openPrestadores);
  };

  const handleClickValidarXML = () => {
    setOpenValidarXML(!openValidarXML);
  };
  return (
    <StyledDrawer.Root open={drawerOpen}>
      {roles && roles.ADMIN && roles.tipo === "Administrador" && (
        <div>
          <DrawerItemTooltip
            drawerOpen={drawerOpen}
            tooltipText="Configuración">
            <StyledDrawer.NodeParent
              button
              onClick={handleClickMenu}
              id="configuration">
              <ListItemIcon>
                <StyledDrawer.ConfigurationIcon fontSize="small" />
              </ListItemIcon>
              <StyledDrawer.NodeParentText>
                Configuración
              </StyledDrawer.NodeParentText>
              {openMenu ? (
                <StyledDrawer.ExpandArrow>
                  <ExpandLess />
                </StyledDrawer.ExpandArrow>
              ) : (
                <StyledDrawer.ExpandArrow>
                  <ExpandMore />
                </StyledDrawer.ExpandArrow>
              )}
            </StyledDrawer.NodeParent>
          </DrawerItemTooltip>
          <Collapse in={openMenu} timeout="auto" unmountOnExit>
            <StyledDrawer.IndentedContainer open={drawerOpen}>
              <DrawerItemTooltip
                drawerOpen={drawerOpen}
                tooltipText={"Siniestros"}
              >
                <StyledDrawer.NodeParent
                  onClick={() => setOpenAccidents(!openAccidents)}
                  button
                  id="siniestros"
                >
                  <StyledDrawer.SubItemIcon open={drawerOpen}>
                    <Assignment />
                  </StyledDrawer.SubItemIcon>
                  <StyledDrawer.NodeParentText>
                    Siniestros
                  </StyledDrawer.NodeParentText>
                  {openAccidents ?
                    <StyledDrawer.ExpandArrow>
                      <ExpandLess />
                    </StyledDrawer.ExpandArrow>
                    :
                    <StyledDrawer.ExpandArrow>
                      <ExpandMore />
                    </StyledDrawer.ExpandArrow>
                  }
                </StyledDrawer.NodeParent>
              </DrawerItemTooltip>
              <Collapse in={openAccidents} timeout="auto" unmountOnExit>
                <StyledDrawer.IndentedContainer open={drawerOpen}>
                  <ListSubItemComponent
                    path="/accidents/search"
                    selected={location.pathname === "/accidents/search"}
                    title="Buscar"
                    id="/accidents_search"
                    icon={
                      <StyledDrawer.Icon>
                        <Search />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                </StyledDrawer.IndentedContainer>
              </Collapse>
            </StyledDrawer.IndentedContainer>
            <StyledDrawer.IndentedContainer open={drawerOpen}>
              <DrawerItemTooltip
                drawerOpen={drawerOpen}
                tooltipText={"Novedades"}
              >
                <StyledDrawer.NodeParent
                  onClick={() => setOpenNovedades(!openNovedades)}
                  button
                  id="novedades"
                >
                  <StyledDrawer.SubItemIcon open={drawerOpen}>
                    <AssignmentReturnedOutlined />
                  </StyledDrawer.SubItemIcon>
                  <StyledDrawer.NodeParentText>
                    Novedades
                  </StyledDrawer.NodeParentText>
                  {openNovedades ?
                    <StyledDrawer.ExpandArrow>
                      <ExpandLess />
                    </StyledDrawer.ExpandArrow>
                    :
                    <StyledDrawer.ExpandArrow>
                      <ExpandMore />
                    </StyledDrawer.ExpandArrow>
                  }
                </StyledDrawer.NodeParent>
              </DrawerItemTooltip>
              <Collapse in={openNovedades} timeout="auto" unmountOnExit>
                <StyledDrawer.IndentedContainer open={drawerOpen}>
                  <ListSubItemComponent
                    path="/novedades/search"
                    selected={location.pathname === "/novedades/search"}
                    title="Buscar"
                    id="novedades_search"
                    icon={
                      <StyledDrawer.Icon>
                        <Search />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                  <ListSubItemComponent
                    path="/novedades/temporal"
                    selected={location.pathname === "/novedades/temporal"}
                    title="Temporales"
                    id="novedades_temporal"
                    icon={<StyledDrawer.Icon as={Search} />}
                    open={drawerOpen}
                  />
                  <ListSubItemComponent
                    path="/novedades/xml"
                    selected={location.pathname === "/novedades/xml"}
                    title="XML"
                    id="xml_news"
                    icon={
                      <StyledDrawer.Icon>
                        <Attachment />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                  <ListSubItemComponent
                    path="/novedades/respuestas"
                    selected={location.pathname === "/novedades/respuestas"}
                    title="Respuestas"
                    id="novedades_respuestas"
                    icon={
                      <StyledDrawer.Icon>
                        <Send />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                </StyledDrawer.IndentedContainer>
              </Collapse>
            </StyledDrawer.IndentedContainer>
            <StyledDrawer.IndentedContainer open={drawerOpen}>
              <DrawerItemTooltip
                drawerOpen={drawerOpen}
                tooltipText={"Turnos"}
              >
                <StyledDrawer.NodeParent
                  onClick={() => setOpenAppointment(!openAppointment)}
                  button
                  id="turnos"
                >
                  <StyledDrawer.SubItemIcon open={drawerOpen}>
                    <Event />
                  </StyledDrawer.SubItemIcon>
                  <StyledDrawer.NodeParentText>
                    Turnos
                  </StyledDrawer.NodeParentText>
                  {openAppointment ?
                    <StyledDrawer.ExpandArrow>
                      <ExpandLess />
                    </StyledDrawer.ExpandArrow>
                    :
                    <StyledDrawer.ExpandArrow>
                      <ExpandMore />
                    </StyledDrawer.ExpandArrow>
                  }
                </StyledDrawer.NodeParent>
              </DrawerItemTooltip>
              <Collapse in={openAppointment} timeout="auto" unmountOnExit>
                <StyledDrawer.IndentedContainer open={drawerOpen}>
                  <ListSubItemComponent
                    path="/turnos/search"
                    selected={location.pathname === "/turnos/search"}
                    title="Buscar"
                    id="turnos_search"
                    icon={
                      <StyledDrawer.Icon>
                        <Search />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                </StyledDrawer.IndentedContainer>
              </Collapse>
            </StyledDrawer.IndentedContainer>
            <StyledDrawer.IndentedContainer open={drawerOpen}>
              <DrawerItemTooltip
                drawerOpen={drawerOpen}
                tooltipText="Usuarios">
                <StyledDrawer.NodeParent
                  button
                  onClick={() => setOpenUsuarios(!openUsuarios)}
                  id="usuarios">
                  <StyledDrawer.SubItemIcon open={drawerOpen}>
                    <PeopleOutline />
                  </StyledDrawer.SubItemIcon>
                  <StyledDrawer.NodeParentText>
                    Usuarios
                  </StyledDrawer.NodeParentText>
                  {openUsuarios ? (
                    <StyledDrawer.ExpandArrow>
                      <ExpandLess />
                    </StyledDrawer.ExpandArrow>
                  ) : (
                    <StyledDrawer.ExpandArrow>
                      <ExpandMore />
                    </StyledDrawer.ExpandArrow>
                  )}
                </StyledDrawer.NodeParent>
              </DrawerItemTooltip>
              <Collapse in={openUsuarios} timeout="auto" unmountOnExit>
                <StyledDrawer.IndentedContainer open={drawerOpen}>
                  <ListSubItemComponent
                    path="/configuration/users"
                    selected={location.pathname === "/configuration/users"}
                    title="Usuarios"
                    id="configuration_users"
                    icon={
                      <StyledDrawer.Icon>
                        <PersonIcon />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                  <ListSubItemComponent
                    path="/configuration/blockedUsers"
                    selected={location.pathname === "/configuration/blockedUsers"}
                    title="Usuarios Bloqueados"
                    id="configuration_blocked_users"
                    icon={
                      <StyledDrawer.Icon>
                        <LockClockOutlined />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                  <ListSubItemComponent
                    path="/configuration/pendingUsers"
                    selected={location.pathname === "/configuration/pendingUsers"}
                    title="Pendientes"
                    id="configuration_pending_users"
                    icon={
                      <StyledDrawer.Icon>
                        <InfoOutlinedIcon />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                </StyledDrawer.IndentedContainer>
              </Collapse>
            </StyledDrawer.IndentedContainer>
            <StyledDrawer.IndentedContainer open={drawerOpen}>
              <DrawerItemTooltip
                drawerOpen={drawerOpen}
                tooltipText="Art">
                <StyledDrawer.NodeParent
                  button
                  onClick={() => setOpenArt(!openArt)}
                  id="art">
                  <StyledDrawer.SubItemIcon open={drawerOpen}>
                    <AppsOutlined />
                  </StyledDrawer.SubItemIcon>
                  <StyledDrawer.NodeParentText>
                    Art
                  </StyledDrawer.NodeParentText>
                  {openArt ? (
                    <StyledDrawer.ExpandArrow>
                      <ExpandLess />
                    </StyledDrawer.ExpandArrow>
                  ) : (
                    <StyledDrawer.ExpandArrow>
                      <ExpandMore />
                    </StyledDrawer.ExpandArrow>
                  )}
                </StyledDrawer.NodeParent>
              </DrawerItemTooltip>

              <Collapse in={openArt} timeout="auto" unmountOnExit>
                <StyledDrawer.IndentedContainer open={drawerOpen}>
                  <ListSubItemComponent
                    path="/configuration/arts/arts"
                    selected={location.pathname === "/configuration/arts/arts"}
                    title="ARTs"
                    id="configuration_arts"
                    icon={
                      <StyledDrawer.Icon>
                        <AppsOutlined />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                  <ListSubItemComponent
                    path="/configuration/arts/services"
                    selected={location.pathname === "/configuration/arts/services"}
                    title="Prestaciones"
                    id="configuration_arts_services"
                    icon={
                      <StyledDrawer.Icon>
                        <MedicalServicesIcon />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                </StyledDrawer.IndentedContainer>
              </Collapse>
            </StyledDrawer.IndentedContainer>
            <StyledDrawer.IndentedContainer open={drawerOpen}>
              <DrawerItemTooltip
                drawerOpen={drawerOpen}
                tooltipText="Prestadores">
                <StyledDrawer.NodeParent
                  button
                  onClick={handleClickPrestadores}
                  id="prestadores">
                  <StyledDrawer.SubItemIcon open={drawerOpen}>
                    <LocalHospital />
                  </StyledDrawer.SubItemIcon>
                  <StyledDrawer.NodeParentText>
                    Prestadores
                  </StyledDrawer.NodeParentText>
                  {openPrestadores ? (
                    <StyledDrawer.ExpandArrow>
                      <ExpandLess />
                    </StyledDrawer.ExpandArrow>
                  ) : (
                    <StyledDrawer.ExpandArrow>
                      <ExpandMore />
                    </StyledDrawer.ExpandArrow>
                  )}
                </StyledDrawer.NodeParent>
              </DrawerItemTooltip>
              <Collapse in={openPrestadores} timeout="auto" unmountOnExit>
                <StyledDrawer.IndentedContainer open={drawerOpen}>
                  <ListSubItemComponent
                    path="/configuration/providers"
                    selected={location.pathname === "/configuration/providers"}
                    title="Prestadores"
                    id="configuration_providers"
                    icon={
                      <StyledDrawer.Icon>
                        <LocalHospitalOutlined />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                  <ListSubItemComponent
                    path="/configuration/providers/datacenter"
                    selected={location.pathname === "/configuration/providers/datacenter"}
                    title="DataCenter"
                    id="configuration_providers_datacenter"
                    icon={
                      <StyledDrawer.Icon>
                        <Add />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                  <ListSubItemComponent
                    path="/configuration/providerServices"
                    selected={location.pathname === "/configuration/providerServices"}
                    title="Prestaciones"
                    id="configuration_provider_services"
                    icon={
                      <StyledDrawer.Icon>
                        <MedicalServicesIcon />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                  <ListSubItemComponent
                    path="/configuration/statistics"
                    selected={location.pathname === "/configuration/statistics"}
                    title="Estadísticas"
                    id="configuration_providers_statistics"
                    icon={
                      <StyledDrawer.Icon>
                        <Search />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                </StyledDrawer.IndentedContainer>
              </Collapse>
            </StyledDrawer.IndentedContainer>
            <ListSubItemComponent
              path="/configuration/files"
              selected={location.pathname === "/configuration/files"}
              title="Archivos"
              id="configuration_files"
              icon={
                <StyledDrawer.Icon>
                  <DescriptionIcon />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
            <ListSubItemComponent
              path="/xml/validation"
              selected={location.pathname === "/xml/validation"}
              title="Validación XML"
              id="configuration_xml"
              icon={
                <StyledDrawer.Icon>
                  <Code />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />

            <ListSubItemComponent
              path="/configuration/serviceMonitor"
              selected={location.pathname === "/configuration/serviceMonitor"}
              title="Monitor de Servicios"
              id="configuration_serviceMonitor"
              icon={
                <StyledDrawer.Icon>
                  <AssignmentLateOutlinedIcon />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
            <StyledDrawer.IndentedContainer open={drawerOpen}>
              <DrawerItemTooltip
                drawerOpen={drawerOpen}
                tooltipText={"Notificaciones"}
              >
                <StyledDrawer.NodeParent
                  onClick={() => setOpenNotificaciones(!openNotificaciones)}
                  button
                  id="notificaciones"
                >
                  <StyledDrawer.SubItemIcon open={drawerOpen}>
                    <NotificationsActiveIcon />
                  </StyledDrawer.SubItemIcon>
                  <StyledDrawer.NodeParentText>
                    Notificaciones
                  </StyledDrawer.NodeParentText>
                  {openNotificaciones ?
                    <StyledDrawer.ExpandArrow>
                      <ExpandLess />
                    </StyledDrawer.ExpandArrow>
                    :
                    <StyledDrawer.ExpandArrow>
                      <ExpandMore />
                    </StyledDrawer.ExpandArrow>
                  }
                </StyledDrawer.NodeParent>
              </DrawerItemTooltip>
              <Collapse in={openNotificaciones} timeout="auto" unmountOnExit>
                <StyledDrawer.IndentedContainer open={drawerOpen}>
                  <ListSubItemComponent
                    path="/notificaciones/nuevo"
                    selected={location.pathname === "/notificaciones/nuevo"}
                    title="Nuevo"
                    id="notificaciones_nuevo"
                    icon={
                      <StyledDrawer.Icon>
                        <Add />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                  <ListSubItemComponent
                    path="/notificaciones/buscar"
                    selected={location.pathname === "/notificaciones/buscar"}
                    title="Buscar"
                    id="notificaciones_buscar"
                    icon={
                      <StyledDrawer.Icon>
                        <Search />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                  <ListSubItemComponent
                    path="/notificaciones/plantillas"
                    selected={location.pathname === "/notificaciones/plantillas"}
                    title="Plantillas Notificaciones"
                    id="notificaciones_plantillas"
                    icon={
                      <StyledDrawer.Icon>
                        <DescriptionIcon />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                </StyledDrawer.IndentedContainer>
              </Collapse>
            </StyledDrawer.IndentedContainer>
            <StyledDrawer.IndentedContainer open={drawerOpen}>
              <DrawerItemTooltip
                drawerOpen={drawerOpen}
                tooltipText={"Configuración de ART"}
              >
                <StyledDrawer.NodeParent
                  onClick={() => setOpenArtConfiguration(!openArtConfiguration)}
                  button
                  id="configuracion_art"
                >
                  <StyledDrawer.SubItemIcon open={drawerOpen}>
                    <Assignment />
                  </StyledDrawer.SubItemIcon>
                  <StyledDrawer.NodeParentText>
                    Configuración de ART
                  </StyledDrawer.NodeParentText>
                  {openArtConfiguration ?
                    <StyledDrawer.ExpandArrow>
                      <ExpandLess />
                    </StyledDrawer.ExpandArrow>
                    :
                    <StyledDrawer.ExpandArrow>
                      <ExpandMore />
                    </StyledDrawer.ExpandArrow>
                  }
                </StyledDrawer.NodeParent>
              </DrawerItemTooltip>
              <Collapse in={openArtConfiguration} timeout="auto" unmountOnExit>
                <StyledDrawer.IndentedContainer open={drawerOpen}>
                  <ListSubItemComponent
                    path="/configuration/artConfiguration/forms"
                    selected={location.pathname === "/configuration/artConfiguration/forms"}
                    title="Permisos Roles"
                    id="/configuration_artConfiguration_forms"
                    icon={
                      <StyledDrawer.Icon>
                        <Search />
                      </StyledDrawer.Icon>
                    }
                    open={drawerOpen}
                  />
                </StyledDrawer.IndentedContainer>
              </Collapse>
            </StyledDrawer.IndentedContainer>
          </Collapse>
        </div>
      )}
      {roles && roles.SOPORTE && roles.tipo === "Soporte" && (
        <div>
          <DrawerItemTooltip
            drawerOpen={drawerOpen}
            tooltipText="Configuración">
            <StyledDrawer.NodeParent
              button
              onClick={handleClickMenu}
              id="configuration">
              <ListItemIcon>
                <SettingsOutlined />
              </ListItemIcon>
              <StyledDrawer.NodeParentText>
                Configuración
              </StyledDrawer.NodeParentText>
              {openMenu ? (
                <StyledDrawer.ExpandArrow as={ExpandLess} />
              ) : (
                <StyledDrawer.ExpandArrow as={ExpandMore} />
              )}
            </StyledDrawer.NodeParent>
          </DrawerItemTooltip>
          <Collapse in={openMenu} timeout="auto" unmountOnExit>
            <ListSubItemComponent
              path="/configuration/users"
              selected={location.pathname === "/configuration/users"}
              title="Usuarios"
              id="configuration_users"
              icon={<StyledDrawer.Icon as={PeopleOutline} />}
              open={drawerOpen}
            />
          </Collapse>
          <DrawerItemTooltip drawerOpen={drawerOpen} tooltipText="Siniestros">
            <StyledDrawer.NodeParent
              button
              onClick={handleClick}
              id="accidents">
              <ListItemIcon>
                <Assignment />
              </ListItemIcon>
              <StyledDrawer.NodeParentText>
                Siniestros
              </StyledDrawer.NodeParentText>
              {open ? (
                <StyledDrawer.ExpandArrow as={ExpandLess} />
              ) : (
                <StyledDrawer.ExpandArrow as={ExpandMore} />
              )}
            </StyledDrawer.NodeParent>
          </DrawerItemTooltip>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <ListSubItemComponent
              path="/accidents/search"
              selected={location.pathname === "/accidents/search"}
              title="Buscar"
              id="accidents_search"
              icon={<StyledDrawer.Icon as={Search} />}
              open={drawerOpen}
            />
          </Collapse>
          <DrawerItemTooltip drawerOpen={drawerOpen} tooltipText="Novedades">
            <StyledDrawer.NodeParent
              button
              onClick={handleClickNovedades}
              id="novedades">
              <ListItemIcon>
                <AssignmentReturnedOutlined />
              </ListItemIcon>
              <StyledDrawer.NodeParentText>
                Novedades
              </StyledDrawer.NodeParentText>
              {openNovedades ? (
                <StyledDrawer.ExpandArrow as={ExpandLess} />
              ) : (
                <StyledDrawer.ExpandArrow as={ExpandMore} />
              )}
            </StyledDrawer.NodeParent>
          </DrawerItemTooltip>
          <Collapse in={openNovedades} timeout="auto" unmountOnExit>
            <ListSubItemComponent
              path="/novedades/search"
              selected={location.pathname === "/novedades/search"}
              title="Buscar"
              id="novedades_search"
              icon={<StyledDrawer.Icon as={Search} />}
              open={drawerOpen}
            />
            <ListSubItemComponent
              path="/novedades/temporal"
              selected={location.pathname === "/novedades/temporal"}
              title="Temporales"
              id="novedades_temporal"
              icon={<StyledDrawer.Icon as={Search} />}
              open={drawerOpen}
            />
            <ListSubItemComponent
              path="/novedades/xml"
              selected={location.pathname === "/novedades/xml"}
              title="XML"
              id="xml_news"
              icon={
                <StyledDrawer.Icon>
                  <Attachment />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
            <ListSubItemComponent
              path="/novedades/respuestas"
              selected={location.pathname === "/novedades/respuestas"}
              title="Respuestas"
              id="novedades_respuestas"
              icon={
                <StyledDrawer.Icon>
                  <Send />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
          </Collapse>

          <DrawerItemTooltip drawerOpen={drawerOpen} tooltipText="Turnos">
            <StyledDrawer.NodeParent
              button
              onClick={handleClickTurnos}
              id="turnos">
              <ListItemIcon>
                <Event />
              </ListItemIcon>
              <StyledDrawer.NodeParentText>
                Turnos
              </StyledDrawer.NodeParentText>
              {openTurnos ? (
                <StyledDrawer.ExpandArrow as={ExpandLess} />
              ) : (
                <StyledDrawer.ExpandArrow as={ExpandMore} />
              )}
            </StyledDrawer.NodeParent>
          </DrawerItemTooltip>
          <Collapse in={openTurnos} timeout="auto" unmountOnExit>
            <ListSubItemComponent
              path="/turnos/search"
              selected={location.pathname === "/turnos/search"}
              title="Buscar"
              id="turnos_search"
              icon={<StyledDrawer.Icon as={Search} />}
              open={drawerOpen}
            />
          </Collapse>
          <DrawerItemTooltip
            drawerOpen={drawerOpen}
            tooltipText="XML">
            <StyledDrawer.NodeParent
              button
              onClick={handleClickValidarXML}
              id="xml">
              <ListItemIcon>
                <Code />
              </ListItemIcon>
              <StyledDrawer.NodeParentText>
                XML
              </StyledDrawer.NodeParentText>
              {openValidarXML ? (
                <StyledDrawer.ExpandArrow as={ExpandLess} />
              ) : (
                <StyledDrawer.ExpandArrow as={ExpandMore} />
              )}
            </StyledDrawer.NodeParent>
          </DrawerItemTooltip>
          <Collapse in={openValidarXML} timeout="auto" unmountOnExit>
            <ListSubItemComponent
              path="/xml/validation"
              selected={location.pathname === "/xml/validation"}
              title="Validación XML"
              id="configuration_xml"
              icon={
                <StyledDrawer.Icon>
                  <Search />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
          </Collapse>
          <ListSubItemComponent
            path="/configuration/serviceMonitor"
            selected={location.pathname === "/configuration/serviceMonitor"}
            title="Monitor de Servicios"
            id="configuration_serviceMonitor"
            icon={
              <StyledDrawer.Icon>
                <AssignmentLateOutlinedIcon />
              </StyledDrawer.Icon>
            }
            open={drawerOpen}
          />
        </div>
      )}
      {roles && roles.ART && (
        <div>
          <ListItemComponent
            open={drawerOpen}
            path="/art/prestadores"
            title="Prestadores"
            id="prestadores"
            icon={<LocalHospital />}
          />
          {roles.tipo === "Supervisor Art" && (
            <ListItemComponent
              open={drawerOpen}
              path="/art/auditoria-prestadores"
              title="Auditoría de Prestadores"
              id="auditoria_prestadores"
              icon={<FactCheck />}
            />
          )}
          <DrawerItemTooltip drawerOpen={drawerOpen} tooltipText="Siniestros">
            <StyledDrawer.NodeParent
              button
              onClick={handleClick}
              id="accidents">
              <ListItemIcon>
                <Assignment />
              </ListItemIcon>
              <StyledDrawer.NodeParentText>
                Siniestros
              </StyledDrawer.NodeParentText>
              {open ? (
                <StyledDrawer.ExpandArrow>
                  <ExpandLess />
                </StyledDrawer.ExpandArrow>
              ) : (
                <StyledDrawer.ExpandArrow>
                  <ExpandMore />
                </StyledDrawer.ExpandArrow>
              )}
            </StyledDrawer.NodeParent>
          </DrawerItemTooltip>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <ListSubItemComponent
              path="/art/accidents/search"
              selected={location.pathname === "/art/accidents/search"}
              title="Buscar"
              id="accidents_search"
              icon={
                <StyledDrawer.Icon>
                  <Search />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
          </Collapse>
        </div>
      )}
      {(roles?.AGENTETRASLADOS || roles?.GESTORSINIESTROS) && (
        <div>
          <ListItemComponent
            open={drawerOpen}
            path="/art/prestadores"
            title="Prestadores"
            id="prestadores"
            icon={<LocalHospital />}
          />
          <DrawerItemTooltip drawerOpen={drawerOpen} tooltipText="Siniestros">
            <StyledDrawer.NodeParent
              button
              onClick={handleClick}
              id="accidents">
              <ListItemIcon>
                <Assignment />
              </ListItemIcon>
              <StyledDrawer.NodeParentText>
                Siniestros
              </StyledDrawer.NodeParentText>
              {open ? (
                <StyledDrawer.ExpandArrow>
                  <ExpandLess />
                </StyledDrawer.ExpandArrow>
              ) : (
                <StyledDrawer.ExpandArrow>
                  <ExpandMore />
                </StyledDrawer.ExpandArrow>
              )}
            </StyledDrawer.NodeParent>
          </DrawerItemTooltip>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <ListSubItemComponent
              path="/art/accidents/search"
              selected={location.pathname === "/art/accidents/search"}
              title="Buscar"
              id="accidents_search"
              icon={
                <StyledDrawer.Icon>
                  <Search />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
            <ListSubItemComponent
              path="/art/accidents/new"
              selected={location.pathname === "/art/accidents/new"}
              title="Nuevo"
              id="accidents_new"
              icon={
                <StyledDrawer.Icon>
                  <Add />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
          </Collapse>
          <DrawerItemTooltip drawerOpen={drawerOpen} tooltipText="Traslados">
            <StyledDrawer.NodeParent
              onClick={() => setOpenTraslados(!openTraslados)}
              id="traslados">
              <ListItemIcon>
                <DirectionsCar />
              </ListItemIcon>
              <StyledDrawer.NodeParentText>
                Traslados
              </StyledDrawer.NodeParentText>
              {openTraslados ? (
                <StyledDrawer.ExpandArrow>
                  <ExpandLess />
                </StyledDrawer.ExpandArrow>
              ) : (
                <StyledDrawer.ExpandArrow>
                  <ExpandMore />
                </StyledDrawer.ExpandArrow>
              )}
            </StyledDrawer.NodeParent>
          </DrawerItemTooltip>
          <Collapse in={openTraslados} timeout="auto" unmountOnExit>
            <ListSubItemComponent
              path="/art/traslados/pendientes"
              selected={location.pathname === "/art/traslados/pendientes"}
              title="Pendientes"
              id="traslados_pendientes"
              icon={
                <StyledDrawer.Icon>
                  <Assignment />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
            <ListSubItemComponent
              path="/art/traslados/search"
              selected={location.pathname === "/art/traslados/search"}
              title="Buscar"
              id="traslados_search"
              icon={
                <StyledDrawer.Icon>
                  <Search />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
            <ListSubItemComponent
              path="/art/traslados/reports"
              selected={location.pathname === "/art/traslados/reports"}
              title="Reportes"
              id="traslados_reports"
              icon={
                <StyledDrawer.Icon>
                  <BarChart />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
            {roles?.AGENTETRASLADOS && (
              <ListSubItemComponent
                path="/art/traslados/agencias"
                selected={location.pathname === "/art/traslados/agencias"}
                title="Agencias"
                id="traslados_agencias"
                icon={
                  <StyledDrawer.Icon>
                    <SettingsOutlined />
                  </StyledDrawer.Icon>
                }
                open={drawerOpen}
              />
            )}
          </Collapse>
        </div>
      )}
              {roles?.PRESTADORTRASLADO && (
          <div>
            <DrawerItemTooltip drawerOpen={drawerOpen} tooltipText="Traslados">
              <StyledDrawer.NodeParent
                onClick={() => setOpenTraslados(!openTraslados)}
                id="traslados">
                <ListItemIcon>
                  <DirectionsCar />
                </ListItemIcon>
                <StyledDrawer.NodeParentText>
                  Traslados
                </StyledDrawer.NodeParentText>
                {openTraslados ? (
                  <StyledDrawer.ExpandArrow>
                    <ExpandLess />
                  </StyledDrawer.ExpandArrow>
                ) : (
                  <StyledDrawer.ExpandArrow>
                    <ExpandMore />
                  </StyledDrawer.ExpandArrow>
                )}
              </StyledDrawer.NodeParent>
            </DrawerItemTooltip>
            <Collapse in={openTraslados} timeout="auto" unmountOnExit>
              <ListSubItemComponent
                path="/art/traslados/search"
                selected={location.pathname === "/art/traslados/search"}
                title="Buscar"
                id="traslados_search"
                icon={
                  <StyledDrawer.Icon>
                    <Search />
                  </StyledDrawer.Icon>
                }
                open={drawerOpen}
              />
            </Collapse>
          </div>
        )}
        {roles && roles.PRESTADOR && (
        <div>
          <ListItemComponent
            open={drawerOpen}
            path="/home"
            title="Inicio"
            id="home"
            icon={
              <StyledDrawer.Icon>
                <Home />
              </StyledDrawer.Icon>
            }
          />
          <ListItemComponent
            open={drawerOpen}
            path="/myWris"
            title="Mis ARTs"
            id="myWris"
            icon={
              <StyledDrawer.Icon>
                <AppsOutlined />
              </StyledDrawer.Icon>
            }
          />
          <DrawerItemTooltip drawerOpen={drawerOpen} tooltipText="Siniestros">
            <StyledDrawer.NodeParent
              button
              onClick={handleClick}
              id="accidents">
              <ListItemIcon>
                <Assignment />
              </ListItemIcon>
              <StyledDrawer.NodeParentText>
                Siniestros
              </StyledDrawer.NodeParentText>
              {open ? (
                <StyledDrawer.ExpandArrow>
                  <ExpandLess />
                </StyledDrawer.ExpandArrow>
              ) : (
                <StyledDrawer.ExpandArrow>
                  <ExpandMore />
                </StyledDrawer.ExpandArrow>
              )}
            </StyledDrawer.NodeParent>
          </DrawerItemTooltip>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <ListSubItemComponent
              path="/accidents/current"
              selected={location.pathname === "/accidents/current"}
              title="En curso"
              id="accidents_current"
              icon={
                <StyledDrawer.Icon>
                  <QueryBuilder />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
            <ListSubItemComponent
              path="/accidents/search"
              selected={location.pathname === "/accidents/search"}
              title="Buscar"
              id="accidents_search"
              icon={
                <StyledDrawer.Icon>
                  <Search />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
            <ListSubItemComponent
              path="/accidents/new"
              selected={location.pathname === "/accidents/new"}
              title="Nuevo"
              id="accidents_new"
              icon={
                <StyledDrawer.Icon>
                  <Add />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
            <ListSubItemComponent
              path="/accidents/importIet"
              selected={location.pathname === "/accidents/importIet"}
              title="Importar IET"
              id="import_iet"
              icon={
                <StyledDrawer.Icon>
                  <Attachment />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
          </Collapse>
          <DrawerItemTooltip
            drawerOpen={drawerOpen}
            tooltipText="Autorizaciones">
            <StyledDrawer.NodeParent
              button
              onClick={handleClickAccidents}
              id="authorizations">
              <ListItemIcon>
                <FileCopy />
              </ListItemIcon>
              <StyledDrawer.NodeParentText>
                Autorizaciones
              </StyledDrawer.NodeParentText>
              {openAccidents ? (
                <StyledDrawer.ExpandArrow>
                  <ExpandLess />
                </StyledDrawer.ExpandArrow>
              ) : answeredAuthorizationsCount.count > 0 ? (
                <Badge
                  badgeContent={answeredAuthorizationsCount.count}
                  color="primary"
                />
              ) : (
                <StyledDrawer.ExpandArrow>
                  <ExpandMore />
                </StyledDrawer.ExpandArrow>
              )}
            </StyledDrawer.NodeParent>
          </DrawerItemTooltip>
          <Collapse in={openAccidents} timeout="auto" unmountOnExit>
            <ListSubItemComponent
              path="/authorizations/pending"
              selected={location.pathname === "/authorizations/pending"}
              title="Pendientes"
              id="authorizations_pending"
              icon={
                <StyledDrawer.Icon>
                  <ErrorOutlineRounded />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
            <ListSubItemComponent
              path="/authorizations/answered"
              selected={location.pathname === "/authorizations/answered"}
              title="Respondidas"
              id="authorizations_answered"
              icon={
                <StyledDrawer.Icon>
                  <AssignmentTurnedInOutlined />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
              notification={answeredAuthorizationsCount.count}
            />
            <ListSubItemComponent
              path="/authorizations/search"
              selected={location.pathname === "/authorizations/search"}
              title="Buscar"
              id="authorizations_search"
              icon={
                <StyledDrawer.Icon>
                  <Search />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
          </Collapse>
          <DrawerItemTooltip drawerOpen={drawerOpen} tooltipText="Turnos">
            <StyledDrawer.NodeParent
              button
              onClick={handleClickAppointment}
              id="appointments">
              <ListItemIcon>
                <Event />
              </ListItemIcon>
              <StyledDrawer.NodeParentText>Turnos</StyledDrawer.NodeParentText>
              {openAppointment ? (
                <StyledDrawer.ExpandArrow>
                  <ExpandLess />
                </StyledDrawer.ExpandArrow>
              ) : (
                <StyledDrawer.ExpandArrow>
                  <ExpandMore />
                </StyledDrawer.ExpandArrow>
              )}
            </StyledDrawer.NodeParent>
          </DrawerItemTooltip>

          <Collapse in={openAppointment} timeout="auto" unmountOnExit>
            <ListSubItemComponent
              path="/appointments/pending"
              selected={location.pathname === "/appointments/pending"}
              title="Asistencias"
              title2="pendientes"
              id="appointments_pending"
              icon={
                <StyledDrawer.Icon>
                  <ErrorOutlineRounded />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
            <ListSubItemComponent
              path="/appointments/search"
              selected={location.pathname === "/appointments/search"}
              title="Buscar"
              id="appointments_search"
              icon={
                <StyledDrawer.Icon>
                  <Search />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
            <ListSubItemComponent
              path="/appointments/QR"
              selected={location.pathname === "/appointments/QR"}
              title="Asistencia por QR"
              id="appointments_QR"
              icon={
                <StyledDrawer.Icon>
                  <QrCode2 />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
          </Collapse>
          <DrawerItemTooltip drawerOpen={drawerOpen} tooltipText="Mensajería">
            <StyledDrawer.NodeParent
              button
              onClick={handleClickMensajeria}
              id="mensajeria">
              <ListItemIcon>
                <Email />
              </ListItemIcon>
              <StyledDrawer.NodeParentText>
                Mensajería
              </StyledDrawer.NodeParentText>
              {openMensajeria ? (
                <StyledDrawer.ExpandArrow>
                  <ExpandLess />
                </StyledDrawer.ExpandArrow>
              ) : messagingPendingCount > 0 ? (
                <StyledDrawer.Badge
                  badgeContent={messagingPendingCount}
                  color="primary"
                />
              ) : (
                <StyledDrawer.ExpandArrow>
                  <ExpandMore />
                </StyledDrawer.ExpandArrow>
              )}
            </StyledDrawer.NodeParent>
          </DrawerItemTooltip>
          <Collapse in={openMensajeria} timeout="auto" unmountOnExit>
            <ListSubItemComponent
              path="/messaging/new"
              selected={location.pathname === "/messaging/new"}
              title="Nueva"
              id="mensajeria_nueva"
              icon={
                <StyledDrawer.Icon>
                  <Add />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
            <ListSubItemComponent
              path="/messaging/pending"
              selected={location.pathname === "/messaging/pending"}
              title="Pendientes"
              id="mensajeria_pendientes"
              icon={
                <StyledDrawer.Icon>
                  <ErrorOutlineRounded />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
              notification={messagingPendingCount}
            />
            <ListSubItemComponent
              path="/messaging/waiting"
              selected={location.pathname === "/messaging/waiting"}
              title="En Espera"
              id="mensajeria_waiting"
              icon={
                <StyledDrawer.Icon>
                  <QueryBuilder />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
            <ListSubItemComponent
              path="/messaging/search"
              selected={location.pathname === "/messaging/search"}
              title="Buscar"
              id="mensajeria_search"
              icon={
                <StyledDrawer.Icon>
                  <Search />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
          </Collapse>
          <DrawerItemTooltip
            drawerOpen={drawerOpen}
            tooltipText="Resp. de Conectividad">
            <StyledDrawer.NodeParent
              button
              onClick={handleClickErroresConectividad}
              id="respuestasConectividad">
              <ListItemIcon>
                <AssignmentReturnedOutlined />
              </ListItemIcon>
              <StyledDrawer.NodeParentText>
                Resp. de Conectividad
              </StyledDrawer.NodeParentText>
              {openAccidents ? (
                <StyledDrawer.ExpandArrow>
                  <ExpandLess />
                </StyledDrawer.ExpandArrow>
              ) : erroresConectividadNoProcesados > 0 ? (
                <StyledDrawer.Badge
                  badgeContent={erroresConectividadNoProcesados}
                  color="primary"
                />
              ) : (
                <StyledDrawer.ExpandArrow>
                  <ExpandMore />
                </StyledDrawer.ExpandArrow>
              )}
            </StyledDrawer.NodeParent>
          </DrawerItemTooltip>
          <Collapse in={openErroresConectividad} timeout="auto" unmountOnExit>
            <ListSubItemComponent
              path="/respuestasConectividad/errors"
              selected={location.pathname === "/respuestasConectividad/errors"}
              title="Errores"
              id="errores"
              icon={
                <StyledDrawer.Icon>
                  <AssignmentLateOutlined />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
              notification={erroresConectividadNoProcesados.data}
            />
            <ListSubItemComponent
              path="/respuestasConectividad/search"
              selected={location.pathname === "/respuestasConectividad/search"}
              title="Buscar"
              id="search"
              icon={
                <StyledDrawer.Icon>
                  <Search />
                </StyledDrawer.Icon>
              }
              open={drawerOpen}
            />
          </Collapse>
          <ListItemComponent
            open={drawerOpen}
            path="/statistic"
            title="Estadísticas"
            id="statistic"
            icon={
              <StyledDrawer.Icon>
                <BarChart />
              </StyledDrawer.Icon>
            }
          />
          <ListItemComponent
            open={drawerOpen}
            path="/emails"
            title="Correos"
            id="emails"
            icon={
              <StyledDrawer.Icon>
                <Email />
              </StyledDrawer.Icon>
            }
          />
          <ListItemComponent
            open={drawerOpen}
            path="/usuarios"
            title="Usuarios"
            id="usuarios"
            icon={
              <StyledDrawer.Icon>
                <Person />
              </StyledDrawer.Icon>
            }
          />
        </div>
      )}
    </StyledDrawer.Root>
  );
};
export default NestedList;
